<template lang="pug">
#HomeMap
  Loading(:isLoading="isLoading")
  main(v-if="!isLoading")
    Introduction
    Memorial
    //- ShareForm
    //- Instructions
    Footer
</template>
<script>
import Loading from "@/components/Loading";
import Introduction from "@/components/Introduction";
import Memorial from "@/components/Memorial";
// import ShareForm from "@/components/ShareForm";
// import Instructions from "@/components/Instructions";
import Footer from "@/components/Footer";

export default {
  name: "home",
  components: {
    Loading,
    Introduction,
    Memorial,
    //  ShareForm,
    //  Instructions,
    Footer,
  },
  data() {
    return {
      isLoading: true,
    };
  },
  mounted() {
    setTimeout(() => {
      this.isLoading = false;
    }, 3000);
  },
};
</script>

<style lang="scss">
.home-container {
  max-width: 1440px;
  margin: 0 auto;
}
</style>
